module.exports = "pegasus_template/assets/theme4/medium/6.jpg";